import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue';
    import { getByPath, setByPath } from '@/utils/helpers';
    import { Accordion, AccordionContent, AccordionItem } from '@/components/ui/accordion';
    import { Label } from '@/components/ui/label';
    import { Checkbox } from '@/components/ui/checkbox';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeOptionalInput',
  props: {
    form: {},
    label: {},
    value: {}
  },
  setup(__props: any) {

    const props = __props;

    const resolvedValue = computed({
        get: () => getByPath(props.form, props.value),
        set: (val) => setByPath(props.form, props.value, val),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Accordion), {
    type: "single",
    collapsible: "",
    class: _normalizeClass(["hover:border-secondary rounded-md border p-2 transition-[border-color] duration-200", {
            'border-secondary': resolvedValue.value,
            'border-secondary/20': !resolvedValue.value,
        }]),
    "unmount-on-hide": false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AccordionItem), {
        value: _ctx.value,
        open: resolvedValue.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Label), {
            for: _ctx.value,
            class: "flex cursor-pointer items-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                modelValue: resolvedValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resolvedValue).value = $event)),
                id: _ctx.value
              }, null, 8, ["modelValue", "id"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.label)), 1)
            ]),
            _: 1
          }, 8, ["for"]),
          (_ctx.$slots.default)
            ? (_openBlock(), _createBlock(_unref(AccordionContent), {
                key: 0,
                class: "flex flex-col gap-3 pt-3"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["value", "open"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})